import { render, staticRenderFns } from "./EtfChart.vue?vue&type=template&id=66921b67"
import script from "./EtfChart.vue?vue&type=script&lang=js"
export * from "./EtfChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports